var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#073C50",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1318782,2 C9.95446563,2 8.46320458,3.32558564 8.46320458,5.75975193 L8.46320458,5.75975193 L8.46320458,7.85725823 L6,7.85725823 L6,10.7014618 L8.46320458,10.7014618 L8.46320458,18 L11.4091403,18 L11.4091403,10.7014618 L14.2329821,10.7014618 L14.2338184,7.85725823 L11.4091403,7.85725823 L11.4091403,6.04137893 C11.4091403,5.21776062 11.6384847,4.65659119 12.8226292,4.65659119 L12.8226292,4.65659119 L14.3333333,4.65596581 L14.3333333,2.00354379 L12.1318782,2 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5fa0bc8ae7ee745fb0af3e14e41681ad.svg";
export { ForwardRef as ReactComponent };